import React from "react";
import {render} from "react-dom";
import LinkedProducts from "../LinkedProducts/LinkedProducts";
import ProductTile from "../ProductTile/ProductTile";
import productPageBaseUri from "../../utils/productPageBaseUri";

const createInstance = (sparePartsContainer) => {
  const renderSuccess = (sparePartProducts, parentProductCode, errorMessage) => {
    sparePartsContainer.classList.remove("hidden");
    sparePartsContainer.parentElement.classList.remove('hidden');

    render(
      <LinkedProducts title="Spare parts" errorMessage={errorMessage} sliderWrapperId="pdp-spare-part-slider">
        {sparePartProducts.map(product => (
           <ProductTile
             key={product.productId}
             className="pdp-related-product__product-tile"
             parentProductCode={parentProductCode}
             productCode={product.productId}
             href={`${productPageBaseUri}${product.seoFriendlyUrlPath}`}
             title={product.title}
             heroThumbnail={product.heroThumbnailUrlPath}
         />))}
      </LinkedProducts>,
      sparePartsContainer
    );
  };

  const destroy = () => {
    sparePartsContainer.parentNode.removeChild(sparePartsContainer);
  };

  return {renderSuccess, destroy};
};

export default createInstance;
